import { useState, useEffect } from "react";
import {
  IonContent,
  IonPage,
  IonIcon,
  useIonModal,
  IonSearchbar,
  useIonToast,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonList,
  IonButton,
  isPlatform,
} from "@ionic/react";
import {
  arrowBack,
  arrowForward,
  calendarOutline,
  chevronBackOutline,
  colorWandOutline,
  trash,
} from "ionicons/icons";
import { useSelector } from "react-redux";
import {
  deleteNhcIntegration,
  getNhcIntegrationByAdLicenseNumberFunction,
  getNhcIntegrationByUserIdFunction,
} from "../../services/API";
import Spinner from "../../components/atoms/spinner";
import Button from "../../components/atoms/button";
import citySvg from "../../assets/uicons/svg/fi-ts-city.svg";
import districtSvg from "../../images/district.svg";
import neighborhoodSvg from "../../images/neighborhood.svg";
import emptySvg from "../../images/empty.svg";
import editSvg from "../../images/editSvg.svg";
import navigateSvg from "../../images/navigate.svg";
import { OverlayEventDetail } from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import ErrorModal from "../../components/molecules/errorModal";
import EditNhcIntegrationAdvistment from "../editNhcIntegrationAdvistment";
import { presentToastFunction } from "../../services/genericMethoud/generice";
import { arcgisServicesBaseMinistryUrl, arcgisServicesLandFeatureUrl } from "../../configs/arcgisServices";
import {
  getPolygonCenterPoint,
  requestOptions,
  selectedSymbol,
} from "../../services/genericMethoud/gisMethouds";
import Graphic from "@arcgis/core/Graphic";
import Request from "@arcgis/core/request";
import Polygon from "@arcgis/core/geometry/Polygon";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Point from "@arcgis/core/geometry/Point";
import lastPageSvg from "../../images/lastPage.svg";
import firstPageSvg from "../../images/firstPage.svg";
import Joyride from "react-joyride";
import moment from "moment";
import history from "../../services/history";

const MyAdvertisements = ({
  onDismissMyAdvertisements,
  userId = null,
}: {
  userId: any;
  onDismissMyAdvertisements: (
    data?: string | null | undefined | number,
    role?: string
  ) => void;
}) => {
  const { token } = useSelector((state: any) => state.reducer);
  const { userInfo } = useSelector((state: any) => state.reducer);
  const [data, setData] = useState([]);
  const [acualData, setAcualData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [item, setItem] = useState<any>({});
  const [advItem, setAdvItemData] = useState<any>({});
  let [presentToast] = useIonToast();
  let graphicsLayer: GraphicsLayer = new GraphicsLayer();

  const [presentdeleteModal, dismissdeleteModal] = useIonModal(DeleteModal, {
    itemsData: item,
    allData: data,
    onDismissdismissdeleteModal: (data: string, role: string) =>
      dismissdeleteModal(data, role),
  });

  function openDeleteModal() {
    presentdeleteModal({
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        getAddData();
      },
    });
  }

  const [presentEditAdvertisementModal, dismissEditAdvertisementModal] =
    useIonModal(EditNhcIntegrationAdvistment, {
      advertisementId: item.id,
      objectId: item.objectId,
      adLicenseNumber: item.adLicenseNumber,
      addIDType: item.idType,
      adId: item.id,
      advertisement: advItem,
      onDismissdismisEditAdvertisementModal: (data: string, role: string) =>
        dismissEditAdvertisementModal(data, role),
    });

  function openEditAdvertisementModal(adLicenseNumber: any, idType: any, addId: any) {
    console.log("idType", idType);

    getNhcIntegrationByAdLicenseNumberFunction(adLicenseNumber, idType, addId).then(
      (result) => {
        console.log("getNhcIntegrationByAdLicenseNumberFunction==>", result);
        setIsLoading(false);
        if (result?.data?.message) {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `${result?.data?.message}`
          );
        } else {
          setAdvItemData(result.data.data);
          presentEditAdvertisementModal({
            onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
              getAddData();
            },
          });
        }
      }
    );
  }

  const handleAdds = (filter: any) => {
    if (filter) {
      const newAdds = acualData.filter(function (str: any) {
        return str.adLicenseNumber.toString().includes(filter);
      });
      setData(newAdds);
      setCurrentPage(1);
    } else {
      getAddData();
    }
  };

  function getAddData() {
    getNhcIntegrationByUserIdFunction(userId ?? userInfo.id, token)
      .then((returnedData) => {
        console.log("getNhcIntegrationByUserIdFunction==>", returnedData);
        const sortedData = returnedData.data.sort((a: any, b: any) => b.id - a.id);
        setData(sortedData);
        setAcualData(sortedData);
        
        // Recalculate total pages after data update
        const newTotalPages = Math.ceil(returnedData.data.length / cardsPerPage);
        
        // Adjust currentPage if necessary
        if (currentPage > newTotalPages && newTotalPages > 0) {
          // Current page exceeds new total pages, go to last page
          setCurrentPage(newTotalPages);
        } else if (newTotalPages === 0) {
          // No data left, reset to page 1
          setCurrentPage(1);
        }
        
        setIsLoading(false);
        //debugger;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  //#region zoom to objId
  function createFeatureGraphics(
    type: any,
    geometry: any,
    wiki: any,
    attr: any,
    symbolS: any
  ) {
    console.log("createFeatureGraphics ==>geometry", geometry);
    let fFeature: any;
    switch (type) {
      case "polygon":
        fFeature = new Polygon({
          rings: geometry,
          spatialReference: {
            wkid: wiki,
          },
        });
        break;
      case "point":
        fFeature = new Point({
          x: geometry.x,
          y: geometry.y,
          spatialReference: {
            wkid: wiki,
          },
        });
        break;
    }

    let fFeatureGraphic = new Graphic({
      geometry: fFeature,
      symbol: symbolS,
      attributes: attr,
    });
    return fFeatureGraphic;
  }
  let zoomToLayer = (type: any, geometry: any, wiki: any, ZoomLevel: any) => {
    graphicsLayer.removeAll();
    let fGetGraphic: any = createFeatureGraphics(
      type,
      geometry,
      wiki,
      "",
      selectedSymbol
    );
    graphicsLayer.add(fGetGraphic);

    if (ZoomLevel) {
      let opts = {
        duration: 5000,
      };
      window.mapviews.goTo(
        {
          target: fGetGraphic,
          zoom: 17,
        },
        opts
      );
    } else {
      let gr: any = graphicsLayer.graphics;
      window.mapviews.goTo(gr.items[0].geometry.extent.expand(2));
    }
  };

  let getGraphicFromObj = (obj: any) => {
    let queryOption: any = {
      responseType: "json",
      query: {
        f: "json",
        where: `Parcel_Cod in (${obj}) `,
        returnCountOnly: false,
        outFields: "*",
        returnDistinctValues: false,
        returnGeometry: true,
      },
    };
    Request(arcgisServicesLandFeatureUrl + "1/query", queryOption).then(
      (response: any) => {
        if (response.data.features.length >= 0) {
          zoomToLayer(
            "polygon",
            response.data.features[0].geometry.rings[0],
            4326,
            false
          );
        } else {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `يرجى التاكد من رقم القطعة`
          );
        }
      }
    );
    setIsLoading(false);
  };
  //#endregion
  const [run, setRun]: any = useState(true);
  const [steps] = useState([
    {
      target: ".search-bar",
      content: "حقل البحث: يستخدم للبحث عن الاعلانات.",
      placement: "auto" as const,
      disableBeacon: true,
    },
    {
      target: ".list",
      content: "قائمة الاعلانات: يتم فيه عرض قائمة من الاعلانات.",
    },
    {
      target: ".slide",
      content:
        "قائمة التحكم: يمكنك سحب البطاقة يمينًا او يسارًا لعرض عناصر التجكم.",
    },
    {
      target: ".pagination-controls",
      content:
        "التحكم في الصفحات: يمكنك التنقل بين الصفحات ومن الصفحة السابقة إلى الصفحةالتالية.",
    },
  ]);

  useEffect(() => {
    let advertOpenedFirstTime = window.localStorage.getItem(
      "advertOpenedFirstTime"
    );

    if (advertOpenedFirstTime) {
      setRun(false);
    } else {
      setRun(true);
    }

    getAddData();
    // getParcelsCount();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 3;

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = data.slice(indexOfFirstCard, indexOfLastCard);

  const totalPages = Math.ceil(data.length / cardsPerPage);

  const getPageNumbers = () => {
    const maxPagesToShow = 3;
    let startPage: any, endPage;

    if (totalPages <= maxPagesToShow) {
      // Less than maxPagesToShow total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // More than maxPagesToShow total pages so calculate start and end pages
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
      if (currentPage <= halfMaxPagesToShow) {
        // Current page near the start
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + halfMaxPagesToShow >= totalPages) {
        // Current page near the end
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        // Current page somewhere in the middle
        startPage = currentPage - halfMaxPagesToShow;
        endPage = currentPage + halfMaxPagesToShow;
      }
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  // let [isArcServerWorks, setIsArcServerWorks] = useState(false);

  // const getParcelsCount = () => {
  //   let queryOption: any = requestOptions(
  //     "",
  //     true,
  //     false,
  //     "",
  //     "",
  //     "",
  //     "",
  //     `1=1`
  //   );
  //   Request(arcgisServicesBaseMinistryUrl + "0/query", queryOption).then(
  //     (response: any) => {
  //       //debugger;
  //       if (response.data) {
  //         setIsArcServerWorks(true);
  //       }
  //     }
  //   );
  // };

  return (
    <IonPage>
      {!isLoading && run && (
        <Joyride
          steps={steps}
          run={run}
          continuous={run}
          disableCloseOnEsc={true}
          disableOverlayClose={true}
          showSkipButton={false}
          hideBackButton={true}
          hideCloseButton={true}
          disableScrolling={false}
          showProgress={true}
          locale={{
            back: "الرجوع",
            close: "اغلاق",
            last: "إنهاء",
            next: "التالي",
            skip: "تخطي",
          }}
          callback={(data) => {
            console.log(data);
            if (data.action == "update" && data.index == 2) {
              let ionItemSliding =
                document.getElementsByTagName("ion-item-sliding")[0];
              if (ionItemSliding) {
                ionItemSliding.open("end");
              }
            }
            if (data.status == "finished" || data.action == "reset") {
              window.localStorage.setItem("advertOpenedFirstTime", "true");
            }
            setRun(false);
          }}
          styles={{
            options: {
              zIndex: 10000,
            },
          }}
        />
      )}
      <IonContent>
        {isLoading ? (
          <Spinner isFull={true} color={"primary"} size={"large"} />
        ) : null}
        <div className="w-full relative flex flex-col justify-start items-center h-auto">
          <div
            className={`w-full grid grid-cols-3 bg-primaryColor100 rounded-lg ${
              isPlatform("ios") && "pt-7"
            }`}
          >
            <div className="col-span-1"></div>
            <div
              className={`col-span-1 ${
                isPlatform("ios") ? "py-6" : "py-4"
              } flex flex-row justify-center items-center`}
            >
              <p className="font-bold text-white text-2xl whitespace-nowrap">
                {userId ? "اعلانات الوسيط العقاري" : "اعلاناتي"}
              </p>
            </div>
            <div
              className={`col-span-1 ${
                isPlatform("ios") ? "py-6" : "py-4"
              } px-6 flex flex-row justify-end items-center`}
            >
              <button
                onClick={() => {
                  if (userId) {
                    window.location.assign(`app`);
                    if (window.location.pathname == "/app")
                      window.location.reload();
                  }
                  onDismissMyAdvertisements(null, "cancel");
                }}
                className="flex flex-col justify-center items-center"
              >
                <IonIcon
                  icon={chevronBackOutline}
                  className="text-2xl text-white"
                />
              </button>
            </div>
          </div>
          <div className="w-full flex flex-col justify-start items-center px-4">
            <div className="w-full flex flex-col justify-start items-center px-2 search-bar">
              <IonSearchbar
                placeholder="البحث برقم الاعلان"
                onIonChange={(ev) => handleAdds(ev.detail.value)}
              ></IonSearchbar>
            </div>

            {!userId && (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                  color: "#0031c4",
                  marginBottom: "10px",
                }}
              >
                <span>&#8594; اسحب يمين او يسار لإظهار الأزرار &#8592;</span>
              </div>
            )}

            {currentCards.length > 0 ? (
              currentCards.map((item: any, index) => {
                return (
                  <IonList key={index} className="list slide">
                    <IonItemSliding>
                      {!userId && (
                        <IonItemOptions
                          side="start"
                          style={{ width: "auto", textAlign: "center" }}
                        >
                          <IonItemOption
                            color="none"
                            onClick={() => {
                              setItem(item);
                              openEditAdvertisementModal(
                                item.adLicenseNumber,
                                item.idType,
                                item.id,
                              );
                            }}
                            style={{ fontSize: "19px", width: "3em" }}
                          >
                            <IonIcon slot="top" icon={editSvg}></IonIcon>
                            تعديل
                          </IonItemOption>
                        </IonItemOptions>
                      )}

                      <IonItem lines="none">
                        <div
                          style={{
                            border: "1px solid #e1e1e1",
                            width: "19em",
                            borderRadius: "10px",
                          }}
                          className="shadow-md drop-shadow-md w-full flex flex-row justify-between items-center p-4 mb-4 animate__animated animate__fadeInUp"
                        >
                          <div className="h-full flex flex-col col-span-3 justify-start items-start">
                            <p className="font-bold text-primaryColor100 text-xl">
                              <span>رقم الاعلان: </span>({item.adLicenseNumber})
                            </p>
                            <p className="font-bold text-primaryColor100 text-xl">
                              {item.landTypeDesc}
                            </p>
                            {item.zone && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={districtSvg}
                                  className="font-bold text-darkGreen100 animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-darkGreen100 text-lg mr-2">
                                  الحي :
                                  <span className="text-black">
                                    {item.zone}
                                  </span>
                                </p>
                              </div>
                            )}

                            {item.city && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={citySvg}
                                  className="font-bold text-primaryColor100 animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-primaryColor100 text-lg mr-2">
                                  المدينة:{" "}
                                  <span className="text-black">
                                    {item.city}
                                  </span>
                                </p>
                              </div>
                            )}

                            {item.propertyType && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={neighborhoodSvg}
                                  className="font-bold animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-lg mr-2">
                                  النوع:{" "}
                                  <span className="text-black">
                                    {item.propertyType}
                                  </span>
                                </p>
                              </div>
                            )}

                            {item.creationAddDate && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={calendarOutline}
                                  className="font-bold animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-lg mr-2">
                                  الانشاء:{" "}
                                  <span className="text-black">
                                    {moment(item.creationAddDate).format("L")}
                                  </span>
                                </p>
                              </div>
                            )}

                            {item.endAddDate && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={calendarOutline}
                                  className="font-bold animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-lg mr-2">
                                  الانتهاء:{" "}
                                  <span className="text-black">
                                    {moment(item.endAddDate).format("L")}
                                  </span>
                                </p>
                              </div>
                            )}

                            {item.id && (
                              <div className="flex flex-row justify-start items-center mt-1">
                                <IonIcon
                                  icon={colorWandOutline}
                                  className="font-bold animate__animated animate__fadeInRightBig"
                                  style={{ fontSize: "20px" }}
                                />
                                <p className="text-lg mr-2">
                                  معرف ذكي:
                                  <span className="text-black">{item.id}</span>
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="h-full flex flex-col col-span-2 justify-center items-end">
                            {item.landId && (
                              <div className="flex flex-col justify-end items-center">
                                <p className="font-bold text-primaryColor55 text-xl">
                                  رقم القطعة
                                </p>
                                <p className="text-black text-xl">
                                  {item.landId}
                                </p>
                              </div>
                            )}
                            <div className="flex flex-row justify-start items-center mt-4 ml-5">
                              <IonIcon
                                size="large"
                                icon={navigateSvg}
                                className="text-primaryColor100 text-xl animate__animated animate__fadeInLeftBig"
                                onClick={() => {
                                  console.log(item);
                                  setItem(item);
                                  getGraphicFromObj(item.objectId);
                                  if (userId) {
                                    history.push(`app/${item.objectId}`);
                                    // window.location.assign(
                                    //   `app/${item.objectId}/reload`
                                    // );
                                    // location.reload();
                                  }
                                  onDismissMyAdvertisements(null, "cancel");
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </IonItem>

                      {!userId && (
                        <IonItemOptions
                          side="end"
                          style={{ width: "auto", textAlign: "center" }}
                        >
                          <IonItemOption
                            color="none"
                            onClick={() => {
                              // if (!isArcServerWorks) {
                              //   presentToastFunction(
                              //     presentToast,
                              //     "top",
                              //     "danger",
                              //     `عفوًا بيانات قطع الاراضي غير متاحه حاليًا`
                              //   );
                              //   return;
                              // }
                              setItem(item);
                              openDeleteModal();
                            }}
                            style={{ fontSize: "19px", width: "3em" }}
                          >
                            <IonIcon
                              slot="top"
                              icon={trash}
                              className="text-2xl text-redColor"
                            ></IonIcon>
                            حذف
                          </IonItemOption>
                        </IonItemOptions>
                      )}
                    </IonItemSliding>
                  </IonList>
                );
              })
            ) : (
              <>
                <div className="pt-5">
                  <p className="text-xl font-bold text-redColor mt-2">
                    عفوا لا يوجد اعلانات
                  </p>
                </div>
                <div className="pt-5">
                  <img
                    src={emptySvg}
                    className="animate__animated animate__jello animate__infinite"
                    height={150}
                    width={150}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {currentCards.length > 0 && (
          <div
            className={`pagination-buttons pagination-controls ${
              !isLoading && "animate__animated animate__fadeInDown"
            }`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px",
            }}
          >
            <IonButton
              onClick={handleFirstPage}
              style={{ maxWidth: "50px" }}
              disabled={currentPage === 1}
            >
              <IonIcon icon={firstPageSvg} />
            </IonButton>
            <IonButton
              style={{ maxWidth: "50px" }}
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              <IonIcon icon={arrowForward} />
            </IonButton>
            {getPageNumbers().map((pageNumber) => (
              <IonButton
                style={{ maxWidth: "40px" }}
                key={pageNumber}
                onClick={() => handlePageChange(pageNumber)}
                disabled={currentPage === pageNumber}
              >
                {pageNumber}
              </IonButton>
            ))}
            <IonButton
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              style={{ maxWidth: "50px" }}
            >
              <IonIcon icon={arrowBack} />
            </IonButton>
            <IonButton
              style={{ maxWidth: "50px" }}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              <IonIcon icon={lastPageSvg} />
            </IonButton>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

const DeleteModal = ({
  itemsData,
  allData,
  onDismissdismissdeleteModal,
}: {
  itemsData: any;
  allData: any;
  onDismissdismissdeleteModal: (
    data?: string | null | undefined | number,
    role?: string
  ) => void;
}) => {
  const { token } = useSelector((state: any) => state.reducer);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [presentToast] = useIonToast();

  //model property
  const [presentErrorModal, dismissErrorModal] = useIonModal(ErrorModal, {
    errorTitle: errorTitle,
    errorMessage: errorMessage,
    dismissErrorModal: (data: string, role: string) =>
      dismissErrorModal(data, role),
  });

  function openpErrorModal() {
    presentErrorModal({
      animated: true,
      breakpoints: [1, 1, 1, 0.5, 1],
      initialBreakpoint: 0.5,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }

  return (
    <IonContent>
      {isLoading ? (
        <Spinner
          isFull={false}
          cssExtra={"absolute top-2"}
          color={"primary"}
          size={"large"}
        />
      ) : null}
      <div className="wrapper animate__animated animate__fadeInDown">
        <div className="flex flex-col justify-start items-center py-6">
          <p className="font-bold text-primaryColor100 text-2xl">
            هل انت متأكد من حذف الأعلان ؟
          </p>
          <div className="mt-6 w-full grid grid-cols-2 gap-6 ">
            <div className="flex flex-row justify-end">
              <Button
                size={"small"}
                theme={"danger"}
                text={"نعم"}
                onClick={() => {
                  setIsLoading(true);
                  
                  // Show progress feedback
                  presentToastFunction(
                    presentToast,
                    "top",
                    "primary",
                    "جاري حذف الاعلان..."
                  );

                  deleteNhcIntegration(itemsData.id, token)
                    .then(async () => {
                      // The backend removes or recolours the parcel on the map as
                      // part of the delete now, so the client only refreshes the
                      // layers to show the change.
                      try {
                        window.F_Land_parcels?.refresh();
                        window.F_Land_parcelsHeatmap?.refresh();
                      } catch (error) {
                        console.error("map refresh failed:", error);
                      }

                      presentToastFunction(
                        presentToast,
                        "top",
                        "success",
                        "تم الحذف بنجاح"
                      );
                      setIsLoading(false);
                      onDismissdismissdeleteModal(null, "cancel");
                    })
                    .catch((e) => {
                      setIsLoading(false);
                      setErrorTitle("خطأ");
                      setErrorMessage(e?.response?.data?.message ?? "يرجى المحاولة مرة أخرى");
                      openpErrorModal();
                    });
                }}
              />
            </div>
            <div className="flex flex-row justify-start">
              <Button
                size={"small"}
                theme={"primary"}
                text={"لا"}
                onClick={() => {
                  onDismissdismissdeleteModal(null, "cancel");
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-12 animate__animated animate__fadeInDown">
        <IonIcon
          className="rounded text-redColor animate__animated animate__rubberBand animate__infinite"
          icon={trash}
          style={{ fontSize: "150px" }}
        />
      </div>
    </IonContent>
  );
};

export default MyAdvertisements;
